// extracted by mini-css-extract-plugin
export default {"placeholderSection":"PGstpDtm3zUa5YnVlPlY","placeholderTitle":"I9DiHW9uFm57xWCAsPKg","placeholderSubtitle":"WlIssngzdRmyG8cnY65y","placeholderContentWrapper":"IjmCTC9_J0rhaKkGZLAx"};